import * as React from "react";
import { Card, Button, Divider, Flex, Heading } from "@aws-amplify/ui-react";
import StatusCheckComponent from "../../../components/common/StatusCheckComponent";
import InsuranceSectionIcon from "./InsuranceSectionIcon";
import InsuranceSectionContent from "./InsuranceSectionContent";
import { useProfileInsuranceQuery } from "../../../components/profile/api/useProfileInsuranceQuery";
import { useAuthenticator } from "@aws-amplify/ui-react";

export default function InsuranceCard({ onEditClick }) {
  const { user } = useAuthenticator((context) => [context.user]);
  const {
    data: profileInsuranceData,
    isLoading,
    isSuccess,
  } = useProfileInsuranceQuery(user.userId);

  if (isLoading) {
    return <span>Loading...</span>;
  }

  if (isSuccess) {
    return (
      <Card>
        <Flex
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          padding="32px 32px 32px 32px"
          backgroundColor="rgba(255,255,255,1)"
        >
          <Button
            size="small"
            variation="primary"
            children="Edit"
            onClick={onEditClick}
          />
          <Heading level="5" children="Insurance Information" />
          <Flex>
            <InsuranceSectionIcon />
            <InsuranceSectionContent insuranceData={profileInsuranceData} />
          </Flex>
          <Divider height="1px" size="small" orientation="horizontal"></Divider>
          <Flex gap="6px" direction="column">
            <StatusCheckComponent
              label={`Effective from: ${
                profileInsuranceData?.effectiveDate || ""
              } to ${profileInsuranceData?.effectiveDateEnd}`}
            />
            <StatusCheckComponent
              label={`Last Update: ${profileInsuranceData?.updatedAt || ""}`}
            />
          </Flex>
        </Flex>
      </Card>
    );
  }
}
